var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('outcomes-research-wrapper',{attrs:{"_title":"NOSE HHT Questionnaire"}},[_c('v-app',[_c('outcomes-navbar'),_c('Questionnaire'),_c('outcomes-footer',{attrs:{"copyright":_vm.t(_vm.k.FOOTER_COPYRIGHT)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }